<template>
<div>
 <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>用户管理</el-breadcrumb-item>
  <el-breadcrumb-item>管理员用户</el-breadcrumb-item>
</el-breadcrumb>
<!-- 图片视图 -->
<el-card>
<!-- 搜索区域 -->
<el-row>
  <el-col :span="6">
  <div>
    <el-select v-model="userType" placeholder="用户权限">
      <el-option label="领导" value="4"></el-option>
      <el-option label="老师" value="0"></el-option>
      <el-option label="辅导员" value="5"></el-option>
      <el-option label="管理员" value="2"></el-option>
      <el-option label="全部" value=""></el-option>
    </el-select>
    <el-button slot="append" icon="el-icon-search" @click="gettype"></el-button>
</div>
</el-col>
  <el-col :span="4">
  <el-button type="primary" @click="insertNews" >
添加用户
  </el-button></el-col>
    <el-col :span="3"> <p class="lableforSearch">查询到{{userlist.length}}条数据</p></el-col>
 
</el-row>
<!-- 新闻列表区域 -->
  <el-table
    :data="userlist"
     border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
     ref="multipleTable"
    style="width: 100%"
     @selection-change="handleSelectionChange">
    <el-table-column
      type="selection" 
      width="40"
       >
    </el-table-column>
    <!-- <el-table-column
      prop="username"
      label="用户名"
      width="180">
    </el-table-column> -->
    <el-table-column
      prop="username"
      label="账户"
      width="180">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="180">
    </el-table-column>

       <el-table-column
      prop="mobiles"
      label="手机号码"
      width="180">
    </el-table-column>
        <el-table-column
      prop="type"
      label="用户权限"
      width="180"
      :formatter="stateFormat"
      >
    </el-table-column>

    <el-table-column
      prop="address"
      label="家庭住址"
      width="180">
    </el-table-column>
    <el-table-column
      prop="email"
      label="创建时间"
      width="180">
    </el-table-column>
    <el-table-column
      label="密码重置" 
      width="100">
      <!-- 卡槽 -->
      <template slot-scope="scope">
         <el-button  type="success"  @click="resetpassword(scope.row.userid)"  >重置</el-button>
</template>
    </el-table-column>
        <el-table-column
      label="操作"
      width="220">
      <template slot-scope="scope">
<el-button disabled  @click="updateNew(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
<el-button  @click="deleteUser(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<el-button  @click="setUser(scope.row)" v-if="(scope.row.type==0||scope.row.type==5)&scope.row.authentication==false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-ok"></use></svg></el-button>
      </template>
    </el-table-column>
  </el-table>
   <div style="margin-top: 20px">
    <el-button @click="selectDatas">导出Excel</el-button>
    <el-button @click="toggleSelection()">取消选择</el-button>
  </div>
</el-card>
<!-- 弹窗 -->
<el-dialog
  title="用户添加"
  :visible.sync="insertNew"
  width="50%"
  >
  <!-- 主体区域 -->
  <el-form ref="userRef" :model="userForm" :rules="userRules" label-width="80px">
  <el-form-item label="用户名" prop="username">
    <el-input v-model="userForm.username">
    </el-input>
  </el-form-item>
  <el-form-item label="密码" prop="password">
    <el-input v-model="userForm.password"></el-input>
  </el-form-item>
  <el-form-item label="姓名" prop="name">
    <el-input v-model="userForm.name"> </el-input>
  </el-form-item>
    <el-form-item label="年龄" prop="age">
    <el-input type="number" oninput="if(value.length>3)value=value.slice(0,3)" v-model="userForm.age"></el-input>
  </el-form-item>
    <el-form-item label="用户类别" prop="type">
    <el-radio-group v-model="userForm.type">
      <el-radio  label="4">领导</el-radio>
       <el-radio  label="2">admin</el-radio>
       <el-radio  label="6">行政人员</el-radio>
    </el-radio-group>
  </el-form-item>
  <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="userForm.sex">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
  <el-form-item label="家庭住址" prop="address">
<template slot-scope="scope">
<v-distpicker @selected="onSelect"  v-model="userForm.address"></v-distpicker>
</template>
  </el-form-item>
  <el-form-item label="详细地址" prop="address">
<el-input  v-model="userForm.address" ></el-input>
</el-form-item>
<el-form-item label="手机号" prop="mobiles">
    <el-input v-model="userForm.mobiles" type="number"  oninput="if(value.length>11)value=value.slice(0,11)">
      <el-button slot="append" @click="SendMessage()" v-if="!sendPower">点击发送验证码</el-button>
            <el-button slot="append" v-if="sendPower">请于{{ time }}秒后重试</el-button>
    </el-input> 
    <!-- <button  @click="SendMessage()"  :disabled="sendPower">点击发送验证码</button><span v-if="sendPower">请于{{time}}秒后重试</span> -->
  </el-form-item>
    <el-form-item label="验证码" prop="authCode" >
    <el-input type="number" oninput="if(value.length>6)value=value.slice(0,6)" v-model="userForm.authCode"></el-input>
    
  </el-form-item>
 
  <el-form-item>
  </el-form-item>
</el-form>


  <!-- 底部区域 -->
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="onInsertSubmit">立即添加</el-button>
    <el-button @click="insertNew = false">取 消</el-button>
     <el-button @click="reset()">重置</el-button>
  </span>
</el-dialog>

<el-dialog
  title="用户修改"
  :visible.sync="updateNews"
  width="50%"
  @close="updateClose"
  >
  <!-- 主体区域 -->
  <el-form ref="userRef" :model="userForm" :rules="userRules" label-width="80px">
  <el-form-item label="新闻标题" prop="NEWS_TITLEs">
    <el-input v-model="userForm.NEWS_TITLEs" ></el-input>
  </el-form-item>
  <el-form-item label="新闻内容" prop="NEWS_CONTENTs">
    <el-input type="textarea" v-model="userForm.NEWS_CONTENTs"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="onUpdateSubmit">立即修改</el-button>
  </el-form-item>
</el-form>


  <!-- 底部区域 -->
  <span slot="footer" class="dialog-footer">
     
    <el-button @click="updateNews = false">取 消</el-button>
  </span>
</el-dialog>
</div>
</template>

<script>
 import VDistpicker from 'v-distpicker'
 import { checkMobiles, checkStudentID, checkUsername ,checkPassword} from '@/components/work/until/vaildate.js'
export default {
   components: { VDistpicker },
  data(){
    var checkAge=(rule,value,callback) =>{
     let reg=/^(?:[1-9][0-9]?|1[01][0-9]|120)$/;//年龄是1-120之间有效
     if(!reg.test(value)){
        callback(new Error("年龄不合法"))
     }else{
      callback();
     }
    }
    var checkAddress=(rule,value,callback) =>{
     if(value===''|value===null){
      callback(new Error("请输入地址"))
     }else{
      callback();
     }
    }
    return{
// {name: '', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
        fileList:[{}],
        selectList:[],
         sendPower:false,
          multipleSelection: [],
        time:'',
        userType: '',
        userlist:[],
        news:{},
        insertNew:false,
        updateNews:false,
        old_newsUrl:'',
        userForm:{
          username:'',
          password:'',
          name:'',
          age:'',
          sex:'',
          address:'',
          type:'',
           mobiles:'',
          authCode:'',
           
        },
        userRules:{
          username:[
            {required:true,message:'请输入用户名',trigger:'blur'},
            {validator:checkUsername,trigger:'blur'}
            ],
          password:[
             {required:true,message:'请输入密码',trigger:'blur'},
             { validator:checkPassword , trigger: 'blur' }
          ],
           name:[
            {required:true,message:'请输入姓名',trigger:'blur'},
            {min:2,max:100,message:'姓名的长度在3~10个字符之间'}
            ],
          //  address:[
          //    {validator:checkAddress,trigger:'change'},
            
          // ],
            type:[
            {required:true,message:'选择用户类型',trigger:'change'},
            ],
             mobiles:[
             { required: true, message: '手机号', trigger: 'blur' },
             {validator:checkMobiles, trigger: 'blur' }
          ],
          authCode:[
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { min: 6, max: 6, message: '长度为6位数字', trigger: 'blur' }
          ],
        },
  }},
created(){
  this.getUsers()
},
methods:{
  getUsers(){
          this.axios.post("/user/getUser")
          .then(res => { 
                      if(res.data.status == 1) {                                                       
                                    this.infolist=res.data.result;
                                    this.userlist=res.data.result                                                                                  
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
      },resetpassword(data){
        const that=this
        this.$confirm("确定重置？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/user/resetpassword?userid="+data)
        .then((resp) => {
          if (resp.data.status == 1) {
            that.$message.success("重置成功");
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          that.$message.error("出错");
        })
      }).catch(()=>{});
      },       toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },selectDatas(){
        
      if(this.multipleSelection.length===0){
          this.$message.error("请选择导出列表")
          return
        }
      this.axios({
        url: "/user/exportExcel",   //后端地址
        method: "post",
        data:this.multipleSelection, //请求参数
        headers: {  
        'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
        },
        // contenType:'application/json',
        responseType: "blob"
      })
        .then(res => {
          var _this = this;
    　　let yy = new Date().getFullYear();
    　　let mm = new Date().getMonth()+1;
    　　let dd = new Date().getDate();
    　　let hh = new Date().getHours();
    　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    　　_this.gettime = yy+''+mm+''+dd+''+hh+''+mf+''+ss;
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = "数据报表"+_this.gettime +".xlsx"; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
        })
        },  handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      onSelect: function(data) {
          this.citydata = data.province.value + data.city.value + data.area.value;
          this.userForm.address=this.citydata
          console.log(this.citydata);
          //alert(this.userForm.address)
        },
        stateFormat(row, column) {
    if (row.type === 2) {
      return 'admin'
    }else if(row.type==5){
      return '辅导员'
    }else if(row.type==0){
      return '老师'
    } else  {
      return '领导'
    } 
  },
      newShow(datas){
        this.axios.post("/news/updateNewsShow","NEWSID="+datas.newsid+"&news_show="+datas.news_show)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                             console.log(resp.data.result)                                               
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
      },
      deleteUser(data){
        const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/user/deleteUser?userid="+data.userid)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("删除成功") 
                        that.getUsers()                                                                                                                                                                   
                                }else {
                                   alert("删除失败")                                 
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      }).catch(()=>{});
      },setUser(data){
        const that=this
        this.$confirm("是否给予认证？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "info",//提示类型  success/info/warning/error
      }).then(function(){  
      
        that.axios.post("/user/updateAuthentication?userid="+data.userid)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("认证成功") 
                        that.getUsers()                                                                                                                                                                   
                                }else {
                                   alert("认证失败")                                 
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      }).catch(()=>{});
      },
      insertNews(){
        this.insertNew=true
      }, viUsername(){
              this.axios.post("/user/login")
          .then(resp => {  
                      if(resp.data.status == 1) {              
                                                                                    
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 

        this.updateNews=true
      },updateClose(){
       
      },
          onInsertSubmit() {
            this.$refs.userRef.validate(valid=>{
              if(!valid) 
              return 
              
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      
       const formData = new FormData()
      formData.append("username",this.userForm.username)
      formData.append('password', window.btoa(this.userForm.password))
      formData.append('name', this.userForm.name)
      formData.append('address', this.userForm.address)
      formData.append('age', this.userForm.age)
      formData.append('sex', this.userForm.sex)
      formData.append('type', this.userForm.type)
      formData.append('mobiles', this.userForm.mobiles)
      formData.append('authCode', this.userForm.authCode)
      // this.userForm.username=username
     
        this.axios.post("/user/insertUser",formData,config)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                console.log(resp.data.result)  
                                this.$message.success("添加成功") 
                                this.insertNew=false
                                this.$refs.userRef.resetFields()
                                this.getUsers()       
                                this.setTime(0)        
                                }else {
                                   this.$message.error(resp.data.message)             
                                  //  alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
            })
        
      },gettype(){
        if(this.selectList.length<=0){
            this.selectList=this.userlist
          }
          this.userlist=this.selectList
        this.userlist=this.userlist.filter((item)=>{

            if(this.userType!=''){
              return  this.userType==item.type
           }else{
            return true
           }
          })
      },
      reset(){
        this.$refs.userRef.resetFields()
      },resets(){
        this.$refs.userRef.resetFields()
      }, 
            onUpdateSubmit(){
            this.$refs.userRef.validate(valid=>{
              if(!valid) 
              retrun 
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let fd = new FormData();
      let that = this;
      fd.append("NewsFile",that.userForm.imageUrl)
      fd.append("oldNewsUrl",that.old_newsUrl)
      fd.append('NEWS_TITLE', this.userForm.NEWS_TITLEs);
      fd.append('NEWS_CONTENT', this.userForm.NEWS_CONTENTs);
      fd.append('NEWSID', this.userForm.newID);
      fd.append('new_type', this.userForm.new_type);
      alert(this.fileList[0].url)
        this.axios.post("/news/updateNews",fd,config)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    console.log(resp.data.result)     
                                    location. reload()                                 
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            })          })

            },
            SendMessage(){
         this.$refs.userRef.validateField('mobiles',valid => {
           if (valid) {
            return
           }
            this.setTime(60)
      this.setSendCodeLoadingStat(true)
          this.axios.post("/user/SendMessage?mobiles="+this.userForm.mobiles+"&username="+ this.userForm.username)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                    
                        this.$message.success("发送成功")                     
                                }else {
                                this.$message.error("发送失败")   
                                console.log(resp.data.result)                                  
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
           
        })
         
      },
       setTime(val) {
      this.time = val.toString()
      if (val == 0) {
        //当发送定时器结果为0
        this.setSendCodeLoadingStat(false)
        return
      } else {
        val--
      }
      setTimeout(res => {
        //设置一个定时器，每秒刷新一次
        this.setTime(val)
      }, 1000)
    },
    setSendCodeLoadingStat(state) {
      //发送验证码时的加载动画显示
      this.sendPower = state //更改按钮是否可以点击 true为不可点击
    },
    } ,  }
</script>

<style scoped>
.el-main{
  
    line-height: 0px;
}

  .el-card{
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15) !important;
  }
  element.style {
    height:0px;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
 .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/adminUser.vue